import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-spinner',
  imports: [],
  templateUrl: './loading-spinner.component.html',
  styleUrl: './loading-spinner.component.css',
  host: {
    class: 'block h-full w-full',
  },
})
export class LoadingSpinnerComponent {
  @Input() hasBackground: boolean = false;
}
